// import moment from "moment";
import { FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerListaSeguimiento(obj) {
    try {
        let data = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/seguimiento/obtener-lista-seguimiento",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
        }
        return data;
    } catch (err) {
        console.log("obtenerListaSeguimiento err");
        console.log(err);
        return [];
    }
}

export async function obtenerDetalleSeguimiento(obj) {
    try {
        let data = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/seguimiento/obtener-detalle-seguimiento",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
        }
        return data;
    } catch (err) {
        console.log("obtenerListaSeguimiento err");
        console.log(err);
        return [];
    }
}

export async function obtenerEntradaSalidaGeocerca(obj) {
    try {
        let response = { error: true, message: null, data: null };
        const { code, mensaje, data } = await fetch(
            "https://gestiondeflota.boltrack.net/reportes/RP502BodyV04.rep",
            {
                headers: getHeaders(false),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === FAILURE) {
            response.error = true;
            response.message = mensaje;
            response.data = null;
        }
        if (code === SUCCESS) {
            // data.error = false;
            response.error = false;
            response.message = null;
            response.data = data;
        }
        return response;
    } catch (err) {
        console.log("obtenerEntradaSalidaGeocerca err");
        console.log(err);
        return { error: true, message: err, data: null };
    }
}

export async function obtenerHistorico(obj) {
    try {
        let response = { error: true, message: null, data: null };
        const { code, mensaje, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apirastreogestion/api/historico/obtener-historico",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === FAILURE) {
            response.error = true;
            response.message = mensaje;
            response.data = null;
        }
        if (code === SUCCESS) {
            // data.error = false;
            response.error = false;
            response.message = null;
            response.data = body;
        }
        return response;
    } catch (err) {
        console.log("obtenerEntradaSalidaGeocerca err");
        console.log(err);
        return { error: true, message: err, data: null };
    }
}